import React from 'react';
import { InfoWindow, Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import PropTypes from 'prop-types';

import './MapPage.css';


class MapPage extends React.Component {
  static propTypes = {
    google: PropTypes.object,
    loaded: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    google: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      marker: null,
      markerProps: null,
    };
  }

  onMapClick = () => {
    this.setState({
      marker: null,
      markerProps: null,
    });
  };

  onMarkerClick = (props, marker) => {
    this.setState({
      marker,
      markerProps: props,
    });
  };

  render() {
    const { google, loaded } = this.props;
    const { marker, markerProps } = this.state;

    return (
      <div id="map-page" className="map-page content-wrapper">
        <div className="content">
          <div className="content-wrapper">
            <div className="content">
              <h3>Venues</h3>
              <div className="row">
                <div className="col-xs-6">
                  <h4>Our Lady of Mt. Carmel Shrine</h4>
                  <p>Broadway Avenue, New Manila, Quezon City</p>
                </div>
                <div className="col-xs-6">
                  <h4>Sampaguita Gardens</h4>
                  <p>36 Valencia, Quezon City, Metro Manila</p>
                </div>
              </div>
            </div>
          </div>
          {loaded ?
            <div className="map-wrapper">
              <div>
                <Map
                  google={google}
                  style={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                  }}
                  onClick={this.onMapClick}
                  zoom={15}
                  initialCenter={{
                    lat: 14.6122594,
                    lng: 121.033744,
                  }}
                  scrollwheel={false}
                >
                  <Marker
                    onClick={this.onMarkerClick}
                    name="Our Lady of Mt. Carmel Shrine"
                    location="Broadway Avenue, New Manila, Quezon City"
                    notes="Between the 4th and 5th street"
                    position={{
                      lat: 14.614279,
                      lng: 121.030558,
                    }}
                  />
                  <Marker
                    onClick={this.onMarkerClick}
                    name="Sampaguita Gardens"
                    location="36 Valencia, Quezon City, Metro Manila"
                    notes=""
                    position={{
                      lat: 14.609656,
                      lng: 121.036265,
                    }}
                  />
                  {markerProps &&
                    <InfoWindow
                      marker={marker}
                      visible={marker !== null}
                    >
                      <div>
                        <h4>{markerProps.name}</h4>
                        <p>{markerProps.location}</p>
                        <p>{markerProps.notes}</p>
                      </div>
                    </InfoWindow>
                  }
                </Map>
              </div>
            </div> :
            <p>Loading&hellip;</p>
          }
        </div>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyDih7a_TbNbxLjk2Wjf1Nb6JMSugWHhrLM',
})(MapPage);



// WEBPACK FOOTER //
// ./src/components/MapPage/index.js